// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnalyzeChart_wrapper__3WAXp","inactive":"AnalyzeChart_inactive__11y0E","segmentButton":"AnalyzeChart_segmentButton__27QPD","chart":"AnalyzeChart_chart__AYiKw"};